import React from 'react';
import { IAuditoriaAjusteExerciciosAnterioresResultado } from '../interfaces/IAuditoriaAjusteExerciciosAnteriores';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaAjusteExerciciosAnterioresResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Ajustes de Exercícios Anteriores (CPC 23) — verifica se houve
// movimentação direta em contas de Ajuste de Exercícios Anteriores, sem transitar pelo
// Resultado (DRE). Qualquer lançamento nessas contas já é o evento de risco auditado.
const AuditoriaResumoAjusteExerciciosAnteriores: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.movimentacoesIndevidas?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Ajustes de Exercícios Anteriores</h3>
      <p className='text-muted'>
        Auditoria complementar — movimentação direta em conta de Ajuste de Exercícios Anteriores (CPC 23), sem transitar
        pelo Resultado (DRE), pode retirar receita/despesa de competência anterior da apuração da Receita Bruta. Clique
        para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_AJUSTE_EXERCICIOS_ANTERIORES')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Ajustes de Exercícios Anteriores</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} conta{totalOcorrencias === 1 ? '' : 's'} com movimentação indevida identificada{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD 5%, limitada a 1% da RB (Art. 12, II, Lei 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoAjusteExerciciosAnteriores;
